var _defs, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGfMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "GoldFinder",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "gfPick",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 24) scale(1.35) translate(-24 -24.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 8.6 C16.5 8.6 10.4 14.5 10.4 21.6 C10.4 31.2 24 41 24 41 C24 41 37.6 31.2 37.6 21.6 C37.6 14.5 31.5 8.6 24 8.6 Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 3.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8 27.6 L27.8 16.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2 13.7 C25.7 14.6 29.4 17.4 31.4 21.5"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#FD7218",
    mask: "url(#gfPick)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfMark);
export default __webpack_public_path__ + "static/media/gf-mark.4b25f1a1918f9ac20933f1a4553091f5.svg";
export { ForwardRef as ReactComponent };